// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"92":"05cb5515","902":"c5876da1"}[chunkId] + ".chunk.css";
};